// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609020100/js/" + chunkId + "." + {"44":"2a53083c","225":"bf6786d0","481":"e896832b","486":"3f3f7beb","770":"5bfc98cc"}[chunkId] + ".0.7540951898364215.chunk.js";
};